import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import type { SeverityLevel } from '@shared/modules/severity-levels/severity-levels';
import { formatSeverityLevel } from '@shared/modules/severity-levels/severity-levels';

@Pipe({
    name: 'severityLevel'
})
export class SeverityLevelPipe implements PipeTransform {
    transform(value: SeverityLevel): string {
        return formatSeverityLevel(value);
    }
}
